<div id="selection-wrapper" class="h-full flex flex-col items-stretch">
  <div class="flex flex-row space-x-3 items-stretch">
    <csl-fasteners-set-list
      [sets]="fastenerSets"
      class="sets-list-wrapper flex-1"
      (formChanged)="onFastenersSetChanged($event)"
      cslPerfectScrollbar>
    </csl-fasteners-set-list>

    <csl-custom-hole-schemas-list
      class="hole-list-wrapper flex-1"
      [schemas]="schemas"
      (formChanged)="onHoleSchemaChanged($event)"
      cslPerfectScrollbar>
    </csl-custom-hole-schemas-list>
  </div>
</div>
